<template>
    <div class="page-content">
        <div class="section contact-us">
            <h1>Contact Us</h1>
            <p>Interested in becoming a partner or have some questions for us Send us a line below! </p>

            <form>
                <div class="field">
                    <label>Name</label>
                    <input type="text" placeholder="What should we call you?" />
                </div>
                <div class="field">
                    <label>Email</label>
                    <input type="email" placeholder="Valid email address please!" />
                </div>
                <div class="field">
                    <label>Message</label>
                    <textarea placeholder="What do you have in mind?"></textarea>
                </div>

                <button type="submit" class="main-btn">Send Message</button>
            </form>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'ContactUs',
        beforeCreate: function() {
            let body = document.querySelector('body')
            body.dataset.page = 'contact-us'
        }
    }
</script>

<style scoped lang="scss">
    .section.contact-us {
        background: url('/assets/images/contact_bg.png') no-repeat center;
        background-size: cover;
        position: relative;
        margin-top: 0;
        color: #FFF;

        @media all and (min-width: $breakpoint + 1) {
            padding: 90px 15px 120px;
            height: 100vh;
            max-height: 810px;
        }

        @media all and (max-width: $breakpoint) {
            padding: 40px 15px;
            height: auto;
            max-height: none;
        }
    }

    .section.contact-us::before {
        content: "";
        background-color: rgba(#000, 0.21);
        display: block;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
    }


    .contact-us > * {
        position: relative;
    }


    .contact-us p {
        margin-left: auto;
        margin-right: auto;
        max-width: 582px;
        font-weight: $book;
    }


    form {
        margin: 32px auto 0;
        max-width: 582px;
    }


    .field:not(:first-child) {
        margin-top: 28px;
    }


    label {
        display: block;
        text-transform: uppercase;
        font-weight: $medium;
    }

    [type="text"],
    [type="email"],
    textarea {
        margin-top: 2px;
        width: 100%;
        font-weight: $medium;
        font-size: 12px;
    }

    [type="text"],
    [type="email"] {
        padding: 0 25px;
        height: 36px;
        line-height: 36px;
    }

    textarea {
        padding: 10px 25px;
        height: 154px;
    }


    .main-btn {
        margin: 60px auto 0;
        display: block;

        @media all and (max-width: $breakpoint) {
            margin-top: 20px;
            min-width: 100%;
        }
    }
</style>
